<template>
  <div class="c-stepper c:row-center">
    <div class="c-stepper-minus" @click="throttledOnMinusClick">
      <img v-if="canMinus" src="@/assets/icons/zoom-in-active.svg" alt="" />
      <img v-else src="@/assets/icons/zoom-in-inactive.svg" alt="" />
    </div>
    <div class="c-stepper-value">{{ value }}</div>
    <div class="c-stepper-plus" @click="throttledOnPlusClick">
      <img src="@/assets/icons/zoom-out-active.svg" alt="" />
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: { type: Number, default: 0 },
  },
  watch: {
    min() {
      if (typeof this.min === "number") {
        if (this.value < this.min) {
          this.$emit("input", this.min);
        }
      }
    },
  },
  mounted() {
    if (typeof this.min === "number") {
      if (typeof this.value === "number") {
        if (this.value < this.min) {
          this.$emit("input", this.min);
        }
      } else {
        this.$emit("input", this.min);
      }
    } else if (typeof this.value !== "number") {
      this.$emit("input", 0);
    }
  },
  computed: {
    canMinus() {
      return this.value > this.min;
    },
  },
  created() {
    this.throttledOnMinusClick = throttle(this.minus, 500);
    this.throttledOnPlusClick = throttle(this.plus, 500);
  },
  methods: {
    minus() {
      if (this.canMinus) {
        const value = this.value - 1;
        this.$emit("input", value);
        this.$emit("change", value);
      }
    },
    plus() {
      const value = this.value + 1;
      this.$emit("input", value);
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="less" scoped>
.c-stepper {
  gap: 8/20rem;

  width: max-content;
  height: 20/20rem;

  &-minus,
  &-plus {
    width: 18/20rem;
    height: 18/20rem;
    img {
      width: 18/20rem;
      height: 18/20rem;
    }
  }
  &-value {
    min-width: 20/20rem;
    height: 20/20rem;

    line-height: 20/20rem;
    font-size: 14/20rem;
    font-weight: 400;
    letter-spacing: 0.4/20rem;
    text-align: center;
    color: #000a0a;
  }
}
</style>
